import React, { useState, FC, Dispatch, SetStateAction } from 'react'
import { getArtistArtworks } from 'apis/artwork'
import styles from './artistProfile.module.scss'
import { useSelector } from 'react-redux'
import { getArtworksTotal } from '../selectors'
import useQA from 'hooks/useQA'
import { FetchLoadMoreArtworksType, ArtistArtwork } from '../types'
const PAGE_SIZE = 15
const MAX_RESULTS = 100

type Props = {
  setResults: Dispatch<SetStateAction<ReadonlyArray<ArtistArtwork>>>
  resultsLength: number
  artistID: number
}

const fetchArtworksData = async ({
  userId,
  pageNumber,
  pageSize,
  callback,
}: FetchLoadMoreArtworksType) => {
  // We need to Fetch data
  const artworksData = await getArtistArtworks({ userId, pageNumber, pageSize })
  const { payload, success } = artworksData

  if (!success) {
    const { errorMessage } = payload
    const flashErrorMessage = errorMessage || 'Sorry, problem loading artworks'
    //addMessage(flashErrorMessage, 'error')
  } else {
    callback(payload)
  }
}

const LoadMore: FC<Props> = ({ setResults, resultsLength, artistID }) => {
  const [pageNumber, setPageNumber] = useState(2)
  const [loading, setLoading] = useState(false)
  const totalArtworks = useSelector(getArtworksTotal)
  const { testId } = useQA()
  const loadResults = async () => {
    if (loading) return
    setLoading(true)

    try {
      fetchArtworksData({
        userId: artistID,
        pageNumber,
        pageSize: PAGE_SIZE,
        callback: (data: ReadonlyArray<ArtistArtwork>) => {
          setResults((prev) => [...prev, ...data])
          setPageNumber((prev) => prev + 1)
        },
        //addMessage,
      })
    } catch (error) {
      console.error('Failed to fetch results:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleLoadMore = () => {
    loadResults()
  }

  const shouldHideButton =
    totalArtworks <= 15 || resultsLength >= MAX_RESULTS || resultsLength === totalArtworks

  return (
    <div className={styles.loadMore} {...testId('load-more')}>
      {!shouldHideButton && (
        <button onClick={handleLoadMore} disabled={loading} className={styles.loadMoreButton}>
          <p className={styles.buttonTitle}>Load More Artworks</p>
        </button>
      )}
    </div>
  )
}

export default LoadMore
